<template>
    <transition name="modal">
        <div class="modal-full modal-mask" @click="hide()" v-if="isActive">
            <button class="btn-close" @click="hide()"><i class="pe-7s-close"></i></button>
            <div class="block">
                <div class="wrapper">
                    <img :src="picture" :alt="name" :title="name" @click.stop />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import WeACTCore from '../WeACTCore.js';

export default {
    data() {
        return {
            isActive: false,
            picture: '',
            name: ''
        }
    },
    watch: {
        isActive(curr) {
            if (curr) {
                this.$WeHelper.modalScrollable(true);
            }
            else {
                this.$WeHelper.modalScrollable(false);
            }
        }
    },
    methods: {
        show(picture, name) {
            this.isActive = true;
            this.picture = picture;
            this.name = name;
        },
        hide() {
            this.isActive = false;
        }
    },
    beforeMount() {
        WeACTCore.EventBus.$on('showFullPicture', (content) => {
            this.show(content.picture, content.name);
        });
    }
}
</script>

<style lang="scss">
@import '../scss/Variables.scss';

.modal-full {
    .btn-close {
        position: absolute;
        z-index: 1;
        top: 10px;
        right: 10px;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        font-size: 34px;
        line-height: 30px;
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
    }

    .block {
        display: table;
        width: 100%;
        height: 100%;

        .wrapper {
            display: table-cell;
            vertical-align: middle;
            text-align: center;

            img {
                max-width: 100%;
            }
        }
    }
}
</style>